module.exports = __webpack_public_path__ + "bf3.no1.c650446a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bf3.no1.jpg
// module id = GPL/
// module chunks = 0